var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShowHideBox',{attrs:{"top":_vm.top,"left":_vm.left,"width":"290px","height":"230px","show":_vm.show}},[_c('DigitalTypeLabel',{attrs:{"certified":_vm.certified,"color":_vm.color,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }